import { createTheme } from '@mui/material/styles';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/600.css';
import '@fontsource/lora/400.css';
import '@fontsource/lora/400-italic.css';


const theme = createTheme({
    palette: {
        primary: {
            light: '#f9e8ce', // nejsvětlejší krémová
            main: '#eedfcc', // hlavní teplý tón
            dark: '#a5947b', // skutečně tmavší béžová
            contrastText: '#3d3530', // tmavý text
        },
        secondary: {
            main: '#a8b0a0', // tlumeně zelenkavý kontrast
            light: '#c1c8ba',
            dark: '#8b9385',
            contrastText: '#ffffff',
        },
        background: {
            default: '#f1ebe1', // jemné pozadí
            paper: '#f9f6f0', // světlý odstín pro karty
        },
        text: {
            primary: '#1b1717', // hlavní text
            secondary: '#57534d', // doplňkový text
        },
    },
    typography: {
        fontFamily: "'Inter', system-ui, -apple-system, sans-serif",
        h1: {
            fontFamily: "'Roboto', system-ui, -apple-system, sans-serif",
            fontWeight: 600,
            fontSize: '3.5rem',
            lineHeight: 1.2,
            letterSpacing: '-0.01em',
            '@media (max-width:900px)': {
                fontSize: '2.5rem',
            },
            '@media (max-width:600px)': {
                fontSize: '2rem',
            },
        },
        h2: {
            fontFamily: "'Roboto', system-ui, -apple-system, sans-serif",
            fontWeight: 500,
            fontSize: '2.5rem',
            lineHeight: 1.3,
            '@media (max-width:900px)': {
                fontSize: '2rem',
            },
            '@media (max-width:600px)': {
                fontSize: '1.75rem',
            },
        },
        h3: {
            fontFamily: "'Roboto', system-ui, -apple-system, sans-serif",
            fontWeight: 500,
            fontSize: '1.75rem',
            lineHeight: 1.3,
            '@media (max-width:600px)': {
                fontSize: '1.5rem',
            },
        },
        body1: {
            fontSize: '1rem',
            lineHeight: 1.7,
        },
        body2: {
            fontSize: '0.9rem',
            lineHeight: 1.6,
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: '6px',
                    padding: '10px 28px',
                    fontSize: '1rem',
                    fontWeight: 500,
                    transition: 'all 0.2s ease-in-out',
                },
                containedPrimary: {
                    color: '#3d3530',
                    backgroundColor: '#eedfcc',
                    '&:hover': {
                        backgroundColor: '#d6c3a6',
                    },
                },
                containedSecondary: {
                    backgroundColor: '#a8b0a0',
                    color: '#fff',
                    '&:hover': {
                        backgroundColor: '#8b9385',
                    },
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: '10px',
                    border: '1px solid rgba(61, 53, 48, 0.15)',
                    backgroundColor: '#fffdf9',
                    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05)',
                    transition: 'all 0.2s ease-in-out',
                    '&:hover': {
                        boxShadow: '0 8px 20px rgba(0, 0, 0, 0.08)',
                        transform: 'translateY(-4px)',
                        borderColor: '#eedfcc',
                    },
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#f1ebe1', // ladí s paletou
                    boxShadow: 'none',
                    borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
                    color: '#3d3530',
                },
            },
        },
    },
});

export default theme;
